/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DocumentClassifications = 'VendorAndPurchaser' | 'PurchaserOnly' | 'VendorOnly';

export const DocumentClassifications = {
    VendorAndPurchaser: 'VendorAndPurchaser' as DocumentClassifications,
    PurchaserOnly: 'PurchaserOnly' as DocumentClassifications,
    VendorOnly: 'VendorOnly' as DocumentClassifications
};

